import { JobApi } from 'api-typings/common/common';
import { Job } from './jobs.model';

export function transformJob(job: JobApi): Job {
  if (!job.name || !job.seo_url) {
    throw new ReferenceError(`Job missing required fields`);
  }

  return {
    id: job.id,
    name: job.name,
    local: job.local || false,
    seoUrl: job.seo_url,
  };
}
